export default "__VITE_ASSET__BKsgOg5C__"